export default "__VITE_ASSET__BgZG8GQY__";